export default __webpack_public_path__ + "images/assets/3407a90e4406c5a640d6f66d9a93054b.svg";